import { Link } from "react-router-dom";

export default function AdventEventSection() {
  return (
    <section className="relative bg-foreground-950 py-16 md:py-24 overflow-hidden">
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-primary-400/10 blur-3xl"></div>
      <div className="absolute -bottom-32 -right-16 w-80 h-80 rounded-full bg-secondary-400/10 blur-3xl"></div>

      <div className="relative max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* Einladungskarte */}
          <div className="w-full max-w-[480px] mx-auto lg:mx-0">
            <div className="rounded-lg overflow-hidden border border-foreground-800 shadow-2xl">
              <img
                src="https://static.readdy.ai/image/bb9ec34e8a24d2dc16b2ef021bd18218/591a4986a4bf8aa3d0e8050354507ae4.png"
                alt="Einladung zur Advents-Ausstellung der Floralen Manufaktur Blumen Stöhr am 21. und 22. November 2026"
                title="Advents-Ausstellung 2026 – Blumen Stöhr Leer"
                className="w-full h-auto object-cover object-top"
              />
            </div>
          </div>

          {/* Kurzer Text */}
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary-300/40 text-primary-200 text-xs tracking-[0.18em] uppercase mb-6">
              <i className="ri-sparkling-2-line w-4 h-4 flex items-center justify-center"></i>
              Save the Date
            </span>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-background-50 mb-4 md:mb-6">
              Advents-Ausstellung
            </h2>
            <p className="text-background-300 text-base md:text-lg leading-relaxed mb-6">
              Zwei Tage lang zeigen wir in unserer Floralen Manufaktur winterliche Werkstücke –
              von handgebundenen Adventskränzen bis zu festlichen Gestecken. Kommen Sie vorbei,
              stöbern Sie in Ruhe und nehmen Sie Ideen für die stille Zeit mit.
            </p>

            <div className="space-y-2 text-background-300 text-sm md:text-base mb-6">
              <p className="inline-flex items-center gap-3">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center text-primary-300"></i>
                Samstag, 21.11.2026 · 8.30 – 18.00 Uhr
              </p>
              <p className="inline-flex items-center gap-3">
                <i className="ri-calendar-line w-4 h-4 flex items-center justify-center text-primary-300"></i>
                Sonntag, 22.11.2026 · 10.30 – 13.30 Uhr
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center px-6 py-2.5 bg-primary-300 text-foreground-950 rounded-md text-sm font-medium hover:bg-primary-200 transition-colors whitespace-nowrap"
              >
                Anfahrt & Kontakt
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center ml-2"></i>
              </Link>
              <p className="text-background-400 text-sm">
                Heisfelder Str. 105 · 26789 Leer
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}